module.exports = __webpack_public_path__ + "static/media/icon_huodon_bj.ad061e2e.png";